<template>
  <div>
    <Header
      :leftArrow="true"
      :leftText="''"
      @leftClick="onClickLeft"
      :rightIcons="true"
      @onRefreshClick="onRefresh"
    >
    </Header>
    <div class="wrap notice-area" v-show="noticeListShow">
      <div class="notice-list">
        <div
          v-for="item in noticeList"
          :key="item"
          class="notice-list-item item-case__machine-anomaly"
        >
          <p class="item-data">
            <span class="item-time">{{ item.unanswer_time }}</span>
          </p>
          <p class="item-room">
            <span class="item-room-num">１０１号室</span>
            <span class="item-room-name">{{ item.name }}</span>
          </p>
          <p class="item-message">不在着信</p>
        </div>
      </div>
      <div v-show="noticeList.length == 0" style="color: #1414ea">
        新しいお知らせはありません
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import { GetNoticeList } from "@/services/user";
export default {
  data() {
    return {
      noticeList: [],
      noticeListShow: false,
    };
  },
  components: {
    Header,
  },
  mounted() {
    GetNoticeList().then((res) => {
      this.noticeList = res.data.data;
      this.noticeListShow = true;
    });
  },
  methods: {
    onClickLeft() {
      history.back();
    },
    onRefresh() {
      Toast.loading({
        message: "",
        forbidClick: true,
        duration: 1000,
      });
    },
  },
  watch: {},
};
</script>

<style scoped>
.wrap {
  width: calc(100% - 15px);
  margin: 0 auto;
}
.top {
  padding: 15px;
}
.notice-area {
  margin-top: 10px;
  height: 100vh;
}
.notice-list {
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
}
.notice-list-item {
  width: calc(50% - 4px);
  background: #6199ed;
  border-radius: 4px 4px 8px 4px;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  margin: 0 8px 8px 0;
  position: relative;
  overflow: hidden;
  color: #fff;
  padding: 9px 8px;
}
.notice-list-item.item-case__machine-anomaly {
  background: #ef7777;
}
.notice-list-item::after {
  content: "";
  display: block;
  width: 12px;
  height: 12px;
  background: url("../../assets/img/bg_blue.png") no-repeat bottom right;
  background-size: 100% auto;
  position: absolute;
  right: 0;
  bottom: 0;
}
.notice-list-item.item-case__machine-anomaly::after{
  background: url("../../assets/img/bg_red.png") no-repeat bottom right;
  background-size: 100% auto;
}
.notice-list-item:nth-of-type(2n) {
  margin-right: 0;
}
.item-data {
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  -webkit-align-items: center;
  align-items: center;
}
.item-time {
  font-weight: 400;
  font-size: 10px;
}
.item-room {
  margin: 6px 0;
  padding-left: 40px;
  position: relative;
}
.item-room::before {
  content: "";
  display: block;
  width: 32px;
  height: 32px;
  background-color: #fff;
  border-radius: 4px;
  position: absolute;
  top: 0;
  left: 0;
}
.item-case__machine-anomaly .item-room::before {
  background: url("../../assets/img/notice_incoming-call.png") no-repeat center;
  background-size: 25px auto;
  background-color: #fff;
}
.item-room-num {
  display: block;
  font-weight: 700;
  font-size: 10px;
  line-height: 1;
  margin-bottom: 5px;
}
.item-room-name {
  display: block;
  font-weight: 700;
  font-size: 14px;
  line-height: 150%;
}
.item-message {
  font-weight: 700;
  font-size: 12px;
  line-height: 150%;
}
@media screen and (min-width: 481px) {
  .notice-list-item,
  .notice-list-item:nth-of-type(2n) {
    width: calc(33.3% - 5.3px);
    margin-right: 8px;
  }
  .notice-list-item:nth-of-type(3n) {
    margin-right: 0;
  }
}
@media screen and (min-width: 1023px) {
  .notice-list-item,
  .notice-list-item:nth-of-type(2n),
  .notice-list-item:nth-of-type(3n) {
    width: calc(20% - 6.4px);
    margin-right: 8px;
  }
  .notice-list-item:nth-of-type(5n) {
    margin-right: 0;
  }
}
</style>
